

// import Toogler from '@/components/dashboard/Toggler.vue'
import AlertaConfirmacion from '@/components/AlertaConfirmacion.vue'
import AlertaErrorMensaje from '@/components/AlertaErrorMensaje.vue'
import Reporte from '@/components/Reporte.vue'

import ObtenerUsuario from '@/components/ObtenerUsuario'
import LoginForm from '@/components/LoginForm.vue'
import VueRecaptcha from 'vue-recaptcha'
//import IdleCard from '@/components/IdleCard.vue'
import CustomTabs from '@/components/CustomTabs.vue'
import CustomTabsPulp from '@/components/CustomTabsPulperias.vue'
import UserOptions from '@/components/UserOptions.vue'
import Iva from '@/components/login/Iva'
import Boletas from '@/components/login/Boletas'
import Suplencias from '@/components/login/Suplencias'
import Subsidios from '@/components/login/Subsidios'

import FormSubirArchivoDec from '@/components/forms/FormSubirArchivoDec'
import FormSolicitudSubsidios from '@/components/forms/FormSolicitudSubsidios'
import FormSolicitudSuplencias from '@/components/forms/FormSolicitudSuplencias'
import Pdf from 'vue-pdf'

import CLoginForm from '@/components/portada/LoginForm.vue'
import LoginFormMaintenance from '@/components/portada/LoginFormMaintenance.vue'
import CRecaptchaLogo from '@/components/portada/RecaptchaLogo.vue'
import CNoticia from '@/components/portada/Noticia.vue'
import CNoticiaV2 from '@/components/portada/NoticiaV2.vue'
import CNoticiaV3 from '@/components/portada/NoticiaV3.vue'
import CNoticiaV4 from '@/components/portada/NoticiaV4.vue'

/* ------------------------------- Ascenso ------------------------------ */
import Regular from '@/components/ascenso/Regular.vue'
import Administrativos from '@/components/ascenso/Administrativos.vue'
import Alternativa from '@/components/ascenso/Alternativa.vue'
import Especial from '@/components/ascenso/Especial.vue'
import Dgesttla from '@/components/ascenso/DGESTTLA.vue'

/* ------------------------------- Ascenso 2024 ------------------------------ */
import RegularNormativaGeneralV2 from '@/components/ascenso/RegularNormativaGeneralV2.vue'
import RegularPrimariaV2 from '@/components/ascenso/RegularPrimariaV2.vue'
import RegularSecundariaV2 from '@/components/ascenso/RegularSecundariaV2.vue'
import AdministrativosV2 from '@/components/ascenso/AdministrativosV2.vue'
import AlternativaV2 from '@/components/ascenso/AlternativaV2.vue'
import EspecialV2 from '@/components/ascenso/EspecialV2.vue'
import DgesttlaV2 from '@/components/ascenso/DGESTTLAV2.vue'

/* Institucionalizacion */
import DireccionesDepartamentales from '@/components/institucionalizacion/DireccionesDepartamentales.vue'
import DireccionesDistritales from '@/components/institucionalizacion/DireccionesDistritales.vue'
import DireccionesUnidadesEducativas from '@/components/institucionalizacion/DireccionesUnidadesEducativas.vue'
import DireccionesITTIFA from '@/components/institucionalizacion/DireccionesITTIFA.vue'
import DireccionesESFM from '@/components/institucionalizacion/DireccionesESFM.vue'


export default {
    install: async (Vue) => {
        Vue.component('pdf', Pdf)
        Vue.component('c-obtener-usuario', ObtenerUsuario)
        Vue.component('login-form', LoginForm)
        Vue.component('vue-recaptcha', VueRecaptcha)
        Vue.component('v-user-options', UserOptions)
        Vue.component('v-iva', Iva)
        Vue.component('v-boletas', Boletas)
        Vue.component('v-suplencias', Suplencias)
        Vue.component('v-subsidios', Subsidios)
        //Vue.component("idle-card", IdleCard)

/* ------------------------------- Formularios ------------------------------ */
        Vue.component('c-form-subir-archivo-dec', FormSubirArchivoDec)
        Vue.component('c-form-solicitud-subsidios', FormSolicitudSubsidios)
        Vue.component('c-form-solicitud-suplencias', FormSolicitudSuplencias)

        Vue.component('c-login-form', CLoginForm)
        Vue.component('login-form-maintenance', LoginFormMaintenance)
        Vue.component('c-recaptcha-logo', CRecaptchaLogo)
        Vue.component('c-noticia', CNoticia)
        Vue.component('c-noticia-v2', CNoticiaV2)
        Vue.component('c-noticia-v3', CNoticiaV3)
        Vue.component('c-noticia-v4', CNoticiaV4)
/* ------------------------------- Ascenso ------------------------------ */
        Vue.component('c-ascenso-regular', Regular)
        Vue.component('c-ascenso-administrativos', Administrativos)
        Vue.component('c-ascenso-alternativa', Alternativa)
        Vue.component('c-ascenso-especial', Especial)
        Vue.component('c-ascenso-dgesttla', Dgesttla)
/* ------------------------------- Ascenso 2024 ------------------------------ */
        Vue.component('c-ascenso-normativa-general-v2', RegularNormativaGeneralV2)
        Vue.component('c-ascenso-regular-primaria-v2', RegularPrimariaV2)
        Vue.component('c-ascenso-regular-secundaria-v2', RegularSecundariaV2)
        Vue.component('c-ascenso-administrativos-v2', AdministrativosV2)
        Vue.component('c-ascenso-alternativa-v2', AlternativaV2)
        Vue.component('c-ascenso-especial-v2', EspecialV2)
        Vue.component('c-ascenso-dgesttla-v2', DgesttlaV2)
/* ------------------------------- Ascenso ------------------------------ */
        Vue.component('c-direcciones-departamentales', DireccionesDepartamentales)
        Vue.component('c-direcciones-distritales', DireccionesDistritales)
        Vue.component('c-direcciones-unidades-educativas', DireccionesUnidadesEducativas)
        Vue.component('c-direcciones-itt-ifa', DireccionesITTIFA)
        Vue.component('c-direcciones-esfm', DireccionesESFM)

        const listComponents = {
            'c-alerta-confirmar': AlertaConfirmacion,
            'c-alerta-error-mensaje': AlertaErrorMensaje,
            'c-reporte': Reporte,
            'v-custom-tabs': CustomTabs,
            'v-custom-tabs-pulp': CustomTabsPulp
        }

    // Register components from previus list
        for (const component in listComponents) {
            Vue.component(component, listComponents[component])
        }
    },
}
